<template>
	<div class="omapi-progress-bar">
		<div
			v-for="index in total"
			:key="index"
			class="omapi-progress-bar__step"
			:class="{ 'omapi-progress-bar__step-active': isActive(index) }"
		></div>
	</div>
</template>

<script>
export default {
	props: {
		completed: {
			type: Number,
			default() {
				return 1;
			},
		},
		total: {
			type: Number,
			default() {
				return 1;
			},
		},
	},
	methods: {
		isActive(index) {
			return index <= this.completed;
		},
	},
};
</script>
<style lang="scss">
@import '../../assets/scss/variables';

.omapi-progress-bar {
	display: flex;
	margin: 0 auto 40px;
	justify-content: center;

	&:after {
		background: $color_grey-light;
		content: '';
		display: block;
		height: 2px;
	}

	&__step {
		align-items: center;
		display: flex;
		justify-content: center;

		&:before {
			background: $color_grey-light;
			content: '';
			display: block;
			height: 2px;
			width: 76px;
		}

		&:after {
			background: #dcdde1;
			border: 4px solid $onboarding_color-page-background;
			border-radius: 50%;
			content: '';
			display: block;
			height: 13.3px;
			width: 13.3px;
		}

		&-active {
			&:before {
				background: $color_blue-primary;
			}

			&:after {
				background: $color_blue-primary;
			}
		}

		&:first-child {
			&:before {
				display: none;
			}
		}
	}
}
</style>
